<template>
  <b-overlay :show="load" rounded="lg">
    <div class="app-calendar overflow-hidden border">
      <div class="row no-gutters">
        <!-- Sidebar -->
        <div
          class="
            col
            app-calendar-sidebar
            flex-grow-0
            overflow-hidden
            d-flex
            flex-column
          "
        >
          <div
            class="
              sidebar-wrapper
              d-flex
              justify-content-between
              flex-column flex-grow-1
            "
          >
            <div class="p-2">
              <b-form-group
                id="input-group-29"
                :label="$t('edu_programs.edu_programs')"
                label-for="input-29"
              >
                <v-select
                  v-model="eduProgramId"
                  :options="EduPrograms"
                  class="w-100"
                  label="name"
                  :reduce="(item) => item.id"
                  @input="changeEduPrograms(eduProgramId)"
                />
              </b-form-group>
              <div class="mt-3" id="planned-tasks">
                <h5 class="app-label section-label mb-1">
                  <span class="align-middle">{{
                    $t("edu_courses.edu_courses")
                  }}</span>
                </h5>
                <app-collapse accordion type="margin">
                  <app-collapse-item
                    :title="course.name"
                    v-for="(course, index) in courses"
                    :key="index"
                  >
                    <div
                      v-for="(item, index) in course.edu_contents"
                      :key="index"
                    >
                      <b-button
                        :class="`event${item.id} ${
                          checkEvent(item.id) ? '' : 'fc-event'
                        }`"
                        :variant="`outline-${getType(item.type).color}`"
                        block
                        :ref="item.id"
                        :data-type="item.type"
                        :data-name="item.name"
                        :data-id="item.id"
                        :data-duration="item.duration"
                        :data-description="item.description"
                        :disabled="checkEvent(item.id)"
                      >
                        <feather-icon
                          :icon="getType(item.type).icon"
                          class="amr-50"
                        />
                        <span class="align-middle"> {{ item.name }}</span>
                      </b-button>
                      <!-- <br v-if="item.type!='exam'"> -->
                    </div>
                  </app-collapse-item>
                </app-collapse>
              </div>
            </div>
            <b-img
              :src="require('@/assets/images/pages/calendar-illustration.png')"
            />
          </div>
        </div>

        <!-- Calendar -->
        <div class="col position-relative">
          <div class="card shadow-none border-0 mb-0 rounded-0">
            <div class="card-body pb-0">
              <b-row
                ><b-col lg="6"
                  ><b-form-group
                    id="input-group-29"
                    :label="$t('rooms.rooms')"
                    label-for="input-29"
                  >
                    <b-form-select
                      v-model="room"
                      :options="rooms"
                      text-field="name"
                      value-field="id"
                      @input="changeSemester(num_of_semester)"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg="6"
                  ><b-form-group
                    id="input-group-29 "
                    :label="$t('edu_programs.semester')"
                    label-for="input-29"
                  >
                    <b-form-select
                      v-model="num_of_semester"
                      :options="semesters"
                      text-field="name"
                      value-field="id"
                      @input="changeSemester(num_of_semester)"
                    />
                  </b-form-group> </b-col
              ></b-row>
            </div>

            <hr />
            <div class="card-body pb-0">
              <FullCalendar :options="calendarOptions" ref="calendar" />
            </div>
          </div>
        </div>
      </div>
      <hr />
      <b-row>
        <b-col lg="6">
          <b-button
            block
            :disabled="room == 0 || num_of_semester == 0"
            variant="primary"
            @click="submit()"
          >
            <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
          >
        </b-col>
        <b-col lg="6">
          <b-button block @click="goToTable()" variant="success">
            <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
          >
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import arLocale from "@fullcalendar/core/locales/ar";

import controller from "../../../Controllers/EventsController";
import EduProgramsController from "@/Controllers/EduProgramsController";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import Edu_schemesController from "@/Controllers/Edu_schemesController";
import EduContentController from "@/Controllers/EduContentController";
import vSelect from "vue-select";
import EduContentRoomController from "@/Controllers/EduContentRoomController";

var removeIds = [];
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    AppCollapse,
    AppCollapseItem,
    vSelect,
  },
  mounted() {
    this.setupDraggable();
  },
  data() {
    return {
      calendarOptions: {
        plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
        initialView: "timeGridWeek",
        headerToolbar: {
          start: "sidebarToggle, prev,next, title",
          end: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
        },
        locale: arLocale,

        editable: true,
        droppable: true,
        allDayDefault: false,
        drop: function (arg) {
          arg.draggedEl.classList.remove("fc-event");
          arg.draggedEl.disabled = true;
        },
        eventClick: function (arg) {
          // new code added to delete event from the calender
          if (arg.event._def.extendedProps.share_count > 1) return;
          arg.event.remove();
          console.log(arg.event._def);
          if (arg.event._def.extendedProps.online_class_id)
            removeIds.push(arg.event._def.extendedProps.online_class_id);

          // arg.event._def.publicId
          const collection = document.getElementsByClassName(
            "event" + arg.event._def.publicId
          );
          collection[0].classList.add("fc-event");
          collection[0].disabled = false;
        },

        views: {
          dayGridMonth: {
            buttonText: "شهر",
          },
          timeGridWeek: {
            buttonText: "أسبوع",
          },
          listMonth: {
            buttonText: "يوم",
          },
          timeGridDay: {
            buttonText: "قائمة",
          },
        },
        height: 800,
        contentHeight: 780,
        aspectRatio: 3,
        events: [],
        themeSystem: "bootstrap",
      },
      EduPrograms: [],
      eduProgram: {},
      eduProgramId:0,
      courses: [],
      room: 0,
      rooms: [],
      flixable_course: 0,
      semesters: [],
      removeIds: [],
      num_of_semester: 0,
      load: false,
    };
  },

  async created() {
    //getCourse
    this.EduPrograms = await new EduProgramsController().GetAll({
      with: ["semester", "rooms", "courses.eduContents"],
    });
  },
  methods: {
    getType(type) {
      return new EduContentController().GetType(type);
    },
    setupDraggable() {
      new Draggable(document.getElementById("planned-tasks"), {
        itemSelector: ".fc-event",
        eventData: function (eventEl) {
          return {
            title: eventEl.innerText.trim(),
            duration: eventEl.dataset.duration,
            id: eventEl.dataset.id,
            groupId: `{"id": ${eventEl.dataset.id},"type": "${eventEl.dataset.type}","name": "${eventEl.dataset.name}","description": "${eventEl.dataset.description}"}`,
          };
        },
      });
    },
    handleDateClick: function (arg) {
      alert("date click! " + arg.dateStr);
    },

    changeEduPrograms() {
      this.eduProgram = {};
      this.eduProgram = this.EduPrograms.find((a) => (a.id ==this.eduProgramId));

      const courses = this.eduProgram.courses.filter((a) => a.flixable == 0);
      this.courses = [...new Set(courses)];
      this.rooms = this.eduProgram.rooms;
      this.semesters = this.eduProgram.semester;
    },
    async changeSemester(semester) {
      // let room = this.rooms.find((a) => a.room.id == this.room);

      let apiParams = {};
      apiParams.filter = `room_id|${this.room}&&semester_num|${this.num_of_semester}`;
      apiParams.with = ["getRoom", "getEduContent", "semester"];
      apiParams.withCount = ["share"];
      const data = await new EduContentRoomController().GetAll(apiParams);

      this.calendarOptions.events = [];
      let calendarApi = this.$refs.calendar.getApi();
      var removeEvents = calendarApi.getEvents();
      removeEvents.forEach((event) => {
        event.remove();
      });

      data.forEach((element) => {
        if (element.get_edu_content.edu_course_id != this.flixable_course) {
          let color = "";
          if (element.share_count > 1) color = "#ce7b2c";
          calendarApi.addEvent({
            title: element.get_edu_content.name,
            start: element.start_in,
            end: element.end_in,
            online_class_id: element.online_class_id,
            share_count: element.share_count,
            id: element.get_edu_content.id,
            allDay: false,
            editable: color === "",
            groupId: `{"id": ${element.get_edu_content.id},"type": "${element.get_edu_content.type}","name": "${element.get_edu_content.name}","description": "${element.get_edu_content.description}"}`,
            color: color, // an option!
          });
        }
      });

      this.$forceUpdate();
    },
    checkEvent(id) {
      let calendarApi = this.$refs.calendar.getApi();
      var events = calendarApi.getEvents();
      // console.log(events);
      return events.findIndex((a) => a._def.publicId == id) != -1;
    },
    submit(params) {
      this.load = true;
      const calendarApi = this.$refs.calendar.getApi();
      const events = calendarApi.getEvents();
      const myEvenets = {};

      events.forEach((element) => {
        // if (element._def.extendedProps.share_count > 1) return;
        const onlineClassId = element._def.extendedProps.online_class_id;
        const key = onlineClassId || element._def.publicId;
        const ev = {
          semester_num: this.num_of_semester,
          start_in: element._instance.range.start.toISOString().slice(0, -1),
          end_in: element._instance.range.end.toISOString().slice(0, -1),
          groupId: element._def.groupId,
        };
        if (onlineClassId) ev.online_class_id = onlineClassId;
        myEvenets[key] = ev;
      });

      let data = {
        roomId: this.room,
        semester_num: this.num_of_semester,
        events: myEvenets,
        removeIds,
      };
      new Edu_schemesController().Insert(data).then((a) => {
        this.load = false;
      });
    },
    IsJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.app-calendar .fc .fc-event .fc-event-main {
  text-align: center;
  color: #fff;
}
</style>
